import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Carousel, Skeleton } from 'antd/es';
import { Swiper, SwiperSlide } from 'swiper/react';

import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import SliderAreaVet from '@app/components/UI/Slider/SliderAreaVet';

const arrowIcon = require('@app/images/arrow_circle.svg');
const arrowIconHovered = require('@app/images/button_slider.svg');

const SliderAvatar: React.FC<any> = ({
	item,
	i,
	currentIndex,
	onClick,
}) => {
	const avatarHeight = 236;
	const avatarWidth = 236;

	return (
		<div key={`dot-${item.id}`} onClick={onClick} className={`slider-area-vets__avatars-item ${currentIndex === i ? 'active' : ''}`}>
			<div className="slider-area-vets__avatar">
				<CustomAvatar
					src={item.avatar}
					alt={`Dr. ${item.firstName}`}
					maxWidth={avatarWidth}
					maxHeight={avatarHeight}
				/>
			</div>
			<span className="slider-area-vets__name">{`Dr. ${item.firstName}`}</span>
		</div>
	);
};

const SliderAreaVetCarousel: React.FC<any> = ({ sliderItems }) => {
	const slider = React.useRef<any>(null);
	const sliderAvatar = React.useRef<any>(null);

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const navigate = useNavigate();
	const location: any = useLocation();
	const tabUrl = location.pathname;
	const initialVetId: number | undefined = location?.state?.currentVetId ? location?.state.currentVetId : Number(new URLSearchParams(location?.search)?.get('veterinarian'));
	const findCurrentVet = (list) => {
		const queryVetIndex = list.findIndex((el, i, arr) => el.id === initialVetId);
		// need to find better solution to set initial veterinarian-slide when redirect from home page
		setTimeout(() => {
			setCurrentIndex(queryVetIndex);
		}, 500);
	};

	React.useEffect(() => {
		if (sliderItems.length && initialVetId) {
			findCurrentVet(sliderItems);
		}
	}, [sliderItems]);

	React.useEffect(() => {
		sliderItems.length && navigate(`${tabUrl}?veterinarian=${sliderItems[currentIndex]?.id}`);
		sliderAvatar?.current?.goTo(currentIndex);
		slider?.current?.slideTo(currentIndex);
	}, [currentIndex, sliderAvatar]);

	return (
		<div className="slider-area-vets">
			<div className="slider-area-vets__top">
				<div className="slider-area-vets__avatars">
					<Carousel
						ref={sliderAvatar}
						slidesToShow={5}
						swipeToSlide
						swipe
						infinite={sliderItems.length > 5}
						dots={false}
						variableWidth
						rows={1}
						slidesPerRow={1}
						responsive={[
							{
								breakpoint: 1100,
								settings: {
									slidesToShow: 3,
								},
							},
							{
								breakpoint: 470,
								settings: {
									slidesToShow: 2,
								},
							},
						]}
					>
						{sliderItems.map((item, i) => (
							<SliderAvatar
								item={item}
								i={i}
								currentIndex={currentIndex}
								key={item.id}
								onClick={(e) => {
									setCurrentIndex(i);
								}}
							/>
						))}
					</Carousel>
				</div>
				{sliderItems.length > 5 && (
					<div className="slider-buttons slider-area-vets__button-wrapper">
						<div
							className="slider-button__wrapper"
							onClick={() => {
								const nextIndex = currentIndex + 1;

								if (nextIndex < sliderItems.length) {
									setCurrentIndex(nextIndex);
									slider.current?.slideTo(nextIndex);
									sliderAvatar.current?.next();
								} else {
									setCurrentIndex(0);
									slider.current?.slideTo(0);
									sliderAvatar.current?.goTo(0);
								}
							}}
						>
							<img className="slider-button" src={arrowIcon} alt="Next" />
							<img className="slider-button slider-button_hovered" src={arrowIconHovered} alt="Next" />
						</div>
					</div>
				)}
			</div>
			<div className="slider-area-vets__body">
				{!sliderItems.length ? (
					<Skeleton title={false} paragraph={{ rows: 1, className: 'slider-tes-skeleton' }} active />
				) : (
					<Swiper
						onSwiper={(swiper) => slider.current = swiper}
						slidesPerView={1}
						pagination={false}
						onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
						autoHeight
					>
						{sliderItems.map((item) => (
							<SwiperSlide key={item.id}>
								<SliderAreaVet vet={item} />
							</SwiperSlide>
						))}
					</Swiper>
				)}
			</div>
		</div>
	);
};

export default SliderAreaVetCarousel;
